import React from "react";
import { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import NavButton from '../homepage/header-banner/TopNavButton';
import Footer from '../homepage/footer/Footer';
import './hanbirovn.css';
import '../Style/typo.css'
import { Check } from '@mui/icons-material';
import { ChevronRight } from "@mui/icons-material";
import { ArrowRightAlt } from "@mui/icons-material";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import EmailIcon from '@mui/icons-material/Email';
import ForumIcon from '@mui/icons-material/Forum';
import PhoneIcon from '@mui/icons-material/Phone';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DnsIcon from '@mui/icons-material/Dns';
import GroupsIcon from '@mui/icons-material/Groups';
import ApartmentIcon from '@mui/icons-material/Apartment';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import FadeInSection from "../container/component/Fadeanimation/FadeInSection";
import HeaderVn from "../detailpageVN/Page/component/headervn";
import useIsMobile from "../container/Sidebar/useIsMobile";
import GroupIcon from '@mui/icons-material/Group';
import LazyMap from "../container/component/map/lazymap";
import FooterVn from "../detailpageVN/Page/component/footervn";
import HeaderEn from "../detailpageVN/Page/component/headeren";
import styled from "styled-components";
import FooterEn from "../detailpageVN/Page/component/footeren";
import MapAddress from "./component/map-address";
import langData from '../translations/translations.json';

const ScrollToSection = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const section = document.querySelector(location.hash);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    return null;
};

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

function HanbiroEn() {
    const currentLang = "en";
    const content = langData.headerBan;
    const isMobile = useIsMobile();
    const [activated, setActivated] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setActivated(false);
                    setTimeout(() => setActivated(true), 200);
                }
            },
            { threshold: 0.5 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    const CountUp = ({ start, end, duration, activated }) => {
        const [count, setCount] = useState(start);

        useEffect(() => {
            if (activated) {
                setCount(start);
                let current = start;
                const step = (end - start) / (duration * 60);

                const interval = setInterval(() => {
                    current += step;
                    if (current >= end) {
                        setCount(end);
                        clearInterval(interval);
                    } else {
                        setCount(Math.ceil(current));
                    }
                }, 1000 / 60);

                return () => clearInterval(interval);
            }
        }, [activated, start, end, duration]);

        return <span>{count.toLocaleString()}</span>;
    };


    useEffect(() => {
        const featureBoxes = document.querySelectorAll(".feature-wrap-col-ct");

        featureBoxes.forEach((featureBox) => {
            const slideContainer = featureBox.querySelector(".slides-box");
            const dotsContainer = featureBox.querySelector(".dot-slides-box");
            if (!slideContainer || !dotsContainer) return;

            const totalSlides = slideContainer.querySelectorAll("img").length;
            let currentIndex = 0;

            dotsContainer.innerHTML = "";

            for (let i = 0; i < totalSlides; i++) {
                const dot = document.createElement("div");
                dot.classList.add("dot-item-box");
                if (i === 0) dot.classList.add("active");
                dotsContainer.appendChild(dot);

                dot.addEventListener("click", () => {
                    currentIndex = i;
                    updateSlidePosition();
                    updateDots();
                });
            }

            const dots = dotsContainer.querySelectorAll(".dot-item-box");

            const updateSlidePosition = () => {
                const slideWidth = slideContainer.clientWidth;
                slideContainer.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
            };

            const updateDots = () => {
                dots.forEach((dot, index) => {
                    dot.classList.toggle("active", index === currentIndex);
                });
            };

            const autoSlide = () => {
                currentIndex = (currentIndex + 1) % totalSlides;
                updateSlidePosition();
                updateDots();
            };

            const interval = setInterval(autoSlide, 3000);

            const tabButtons = document.querySelectorAll('[data-bs-toggle="pill"]');
            tabButtons.forEach((tab) => {
                tab.addEventListener("click", () => {
                    currentIndex = 0;
                    updateSlidePosition();
                    updateDots();
                });
            });

            return () => clearInterval(interval);
        });
    }, []);

    return (
        <Sysfont className="hanbirovn">
            <HeaderEn />

            <ScrollToSection />
            <div className="header-ban-wp">
                <div className="fit-block">
                    <FadeInSection>
                        <div className="header-ban-tt-wrap">
                            <div className="header-ban-left">
                                <div>
                                    <p className="main-title typo-white mb-2">Develop and run IT systems</p>
                                    <p className="sub-title-head typo-white">We provide optimized IT solutions tailored to needs,
                                        based on flexible cloud platforms,
                                        helping businesses handle everything from infrastructure, software, hardware
                                        to collaborative AI integration.</p>
                                </div>
                                <div className="group-button">
                                    <button className="button-custom btn-emp typo-14">
                                        <a className="btn-link"
                                            href="https://hanbiro.com/#/en/groupware-free-trial">
                                            Groupware Free Trial
                                        </a>
                                    </button>
                                    <button className="button-custom btn-emp typo-14">
                                        <a className="btn-link" href="https://hanbiro.com/#/en/server-hosting-signup">
                                            Cloud Service Signup
                                        </a>
                                    </button>
                                </div>
                            </div>
                            <div className="header-ban-right">
                                <Link to="#ai-feature2" className="banner-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="down-icon typo-white" />
                                    </div>
                                    <p class="ban-tt-text typo-medium typo-white">{content['aiSolution'][currentLang]}</p>
                                </Link>
                                <Link to="#ai-feature4" className="banner-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="down-icon typo-white" />
                                    </div>
                                    <p className="ban-tt-text typo-medium typo-white">{content['cloudService'][currentLang]}</p>
                                </Link>
                                <Link to="#ai-feature4" className="banner-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="down-icon typo-white" />
                                    </div>
                                    <p className="ban-tt-text typo-medium typo-white">{content['kubernetes'][currentLang]}</p>
                                </Link>
                                <Link to="#ai-feature4" className="banner-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="down-icon typo-white" />
                                    </div>
                                    <p className="ban-tt-text typo-medium typo-white">{content['aiGroupware'][currentLang]}</p>
                                </Link>
                                <Link to="#ai-feature4" className="banner-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="down-icon typo-white" />
                                    </div>
                                    <p class="ban-tt-text typo-medium typo-white">{content['microserviceApi'][currentLang]}</p>
                                </Link>
                            </div>
                        </div>
                    </FadeInSection>


                </div>
            </div>

            <div className="wrap-block" id="ai-LLM">
                <FadeInSection>
                    <div class="fit-block">
                        <div class="wrap-block-tt">
                            <p class="typo-32-mb">AI-Powered Collaboration Platform</p>
                            <p class="typo-21">Enterprise AI & LLM • Server management with strong data privacy</p>
                        </div>

                        <div className="wrap-block-ct">
                            <div className="fea-detail-col">
                                <div className="fea-detail-row">
                                    <div className="fea-detail-item">
                                        <EmailIcon className="fea-icon" />
                                        <div>
                                            <p className="typo-21-sm typo-medium">Email</p>
                                            <p className="typo-14">Summary · Translation · Email Content Suggestion</p>
                                        </div>
                                    </div>
                                    <div className="fea-detail-item">
                                        <ForumIcon className="fea-icon" />
                                        <div>
                                            <p className="typo-21-sm typo-medium">Messenger</p>
                                            <div>
                                                <p className="typo-14">Automatic Translation · Send Message</p>
                                                <p className="typo-14">Summary · Conversation Translation</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="fea-detail-item">
                                        <PhoneIcon className="fea-icon" />
                                        <div>
                                            <p className="typo-21-sm typo-medium">AI Call +</p>
                                            <p className="typo-14">Speech Separation · Summary · Translation</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="fea-detail-row">
                                    <div className="fea-detail-item">
                                        <RequestPageIcon className="fea-icon" />
                                        <div>
                                            <p className="typo-21-sm typo-medium">Approval</p>
                                            <p className="typo-14">Summary · Translation · Drafting</p>
                                        </div>
                                    </div>
                                    <div className="fea-detail-item">
                                        <ConfirmationNumberIcon className="fea-icon" />
                                        <div>
                                            <p className="typo-21-sm typo-medium">Helpdesk</p>
                                            <p className="typo-14">Summary · Translation</p>
                                        </div>
                                    </div>
                                    <div className="fea-detail-item">
                                        <FactCheckIcon className="fea-icon" />
                                        <div>
                                            <p className="typo-21-sm typo-medium">Work Diary</p>
                                            <p className="typo-14">Summary · Translation</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </FadeInSection>
            </div>

            <div class="wrap-block groupware-dt" id="groupware">
                <FadeInSection>
                    <div className="fit-block">
                        <div className="wrap-block-tt">
                            <div className="typo-32">Groupware</div>
                        </div>

                        <div className="groupware-vn-ct">
                            <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                <li className="navtab-item" role="presentation">
                                    <button className="nav-link typo-medium active" id="pills-feat1-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-feat1" type="button" role="tab" aria-controls="pills-feat1"
                                        aria-selected="true">Email</button>
                                </li>
                                <li className="navtab-item" role="presentation">
                                    <button className="nav-link typo-medium" id="pills-feat2-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-feat2" type="button" role="tab" aria-controls="pills-feat2"
                                        aria-selected="false">Messenger</button>
                                </li>
                                <li className="navtab-item" role="presentation">
                                    <button className="nav-link typo-medium" id="pills-feat3-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-feat3" type="button" role="tab" aria-controls="pills-feat3"
                                        aria-selected="false">Helpdesk</button>
                                </li>
                                <li className="navtab-item" role="presentation">
                                    <button className="nav-link typo-medium" id="pills-feat4-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-feat4" type="button" role="tab" aria-controls="pills-feat4"
                                        aria-selected="false">Approval</button>
                                </li>
                                <li className="navtab-item" role="presentation">
                                    <button className="nav-link typo-medium" id="pills-feat5-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-feat5" type="button" role="tab" aria-controls="pills-feat5"
                                        aria-selected="false">HR</button>
                                </li>
                                <li className="navtab-item" role="presentation">
                                    <button className="nav-link typo-medium" id="pills-feat6-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-feat6" type="button" role="tab" aria-controls="pills-feat6"
                                        aria-selected="false">Project</button>
                                </li>
                            </ul>
                            <div className="gw-menu-wrap gw-menu-wrap-tab">
                                <div className="menu-line-wrap">
                                    <p className="menu-entry typo-14">Calendar</p>
                                    <p className="menu-entry typo-14">Contact</p>
                                    <p className="menu-entry typo-14">Board</p>
                                    <p className="menu-entry typo-14">Note</p>
                                    <p className="menu-entry typo-14">Clouddisk</p>
                                    <p className="menu-entry typo-14">Circular</p>
                                    <p className="menu-entry typo-14">Todo</p>
                                    <p className="menu-entry typo-14">Archive</p>
                                    <p className="menu-entry typo-14">Asset</p>
                                    <p className="menu-entry typo-14">Expense</p>
                                </div>
                            </div>
                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane show active" id="pills-feat1" role="tabpanel"
                                    aria-labelledby="pills-feat1-tab">
                                    <div className="feature-wrap-box">
                                        <div className="feature-wrap-col-ct">
                                            <p className="typo-21 typo-medium">Email & Spam Filter</p>
                                            <div className="sub-tt">
                                                <p className="typo-14 gray-6">Provide AI-based translation and summarization functions</p>
                                                <p className="typo-14 gray-6">Built-in spam filter in Groupware system</p>
                                            </div>

                                            <div className="feature-wrap-text">
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">SPF, DKIM, DMARC</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Supports POP3/IMAP, blocks up to 95% spam</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Secure Email, approval email, bulk email</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Integrate external emails, share mailbox
                                                        (Including former employees)</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Share and forward departed employee’s emails</p>
                                                </div>
                                            </div>

                                            <div class="group-button">
                                                <button class="button-custom button-fill typo-14"><a class="btn-link"
                                                    href="https://hanbiro.com/#/en/groupware-free-trial">Free Trial</a></button>
                                            </div>
                                        </div>
                                        <div className="feature-wrap-col-ct">
                                            <div className="feature-wrap-img-ct wrap-shadow">
                                                <div className="slides-box">
                                                    <img src={`https://hanbiro.com/assets/images/cloud/mail-ai-summary-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 1" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/ai-call-en-sm-1.png?v=${new Date().getTime()}`} alt="Slide 2" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/mail-spam-settings-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 3" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/project-view-task-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 4" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/work-diary-ai-summary-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 5" />
                                                </div>
                                            </div>
                                            <div className="dot-slides-box"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="pills-feat2" role="tabpanel" aria-labelledby="pills-feat2-tab">
                                    <div className="feature-wrap-box">
                                        <div className="feature-wrap-col-ct">
                                            <p className="typo-21 typo-medium">Chat & Online meetings</p>
                                            <div className="sub-tt">
                                                <p className="typo-14 gray-6">Flexible real-time communication with team members.</p>
                                            </div>

                                            <div className="feature-wrap-text">
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Summarize and translate online meeting content.</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Live conversation translation • Daily conversation summary</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Support collaboration via screen sharing,
                                                        voice calling,
                                                        and online meetings.</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Allow guests to join online meetings.</p>
                                                </div>
                                            </div>

                                            <div class="group-button">
                                                <button class="button-custom button-fill typo-14"><a class="btn-link"
                                                    href="https://hanbiro.com/#/en/groupware-free-trial">Free Trial</a></button>
                                            </div>
                                        </div>
                                        <div className="feature-wrap-col-ct">
                                            <div className="feature-wrap-img-ct wrap-shadow">
                                                <div className="slides-box">
                                                    <img src={`https://hanbiro.com/assets/images/cloud/mail-ai-summary-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 1" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/ai-call-en-sm-1.png?v=${new Date().getTime()}`} alt="Slide 2" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/mail-spam-settings-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 3" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/project-view-task-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 4" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/work-diary-ai-summary-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 5" />
                                                </div>
                                            </div>
                                            <div className="dot-slides-box"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="pills-feat3" role="tabpanel" aria-labelledby="pills-feat3-tab">
                                    <div className="feature-wrap-box">
                                        <div className="feature-wrap-col-ct">
                                            <div className="fea-sub-tt">
                                                <p className="typo-21 typo-medium">Ticket</p>
                                                <div>
                                                    <p className="typo-14 gray-6">Collect and manage all customer requests in a single platform.</p>
                                                    <p className="typo-14 gray-6">Track and support the entire process from receipt to final response.</p>
                                                </div>
                                            </div>

                                            <div>
                                                <p className="typo-21 typo-medium">AI call +</p>
                                                <div>
                                                    <p className="typo-14 gray-6">Store and analyze call history with customers.</p>
                                                    <p className="typo-14 gray-6">Improve service quality based on call information and related data.</p>
                                                    <p className="typo-14 gray-6">Summarize and translate call content using AI.</p>
                                                </div>
                                            </div>

                                            <div class="group-button">
                                                <button class="button-custom button-fill typo-14"><a class="btn-link"
                                                    href="https://hanbiro.com/#/en/groupware-free-trial">Free Trial</a></button>
                                            </div>
                                        </div>
                                        <div className="feature-wrap-col-ct">
                                            <div className="feature-wrap-img-ct wrap-shadow">
                                                <div className="slides-box">
                                                    <img src={`https://hanbiro.com/assets/images/cloud/mail-ai-summary-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 1" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/ai-call-en-sm-1.png?v=${new Date().getTime()}`} alt="Slide 2" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/mail-spam-settings-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 3" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/project-view-task-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 4" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/work-diary-ai-summary-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 5" />
                                                </div>

                                            </div>
                                            <div className="dot-slides-box"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="pills-feat4" role="tabpanel" aria-labelledby="pills-feat4-tab">
                                    <div className="feature-wrap-box">
                                        <div className="feature-wrap-col-ct">
                                            <p className="typo-21 typo-medium">Approval</p>
                                            <div className="sub-tt">
                                                <p className="typo-14 gray-6">Conduct approval processes anytime,
                                                    anywhere via PC or mobile device,
                                                    enabling quick and efficient work handling.</p>
                                            </div>

                                            <div className="feature-wrap-text">
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Offer approximately 300 basic templates for free</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Support automatic formulas and basic calculations with an Excel editor</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Enhance security with a two-layer approval process</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Set up and save individual approval workflows for each template</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Integrate with ERP, SAP, and other internal management systems</p>
                                                </div>
                                            </div>

                                            <div class="group-button">
                                                <button class="button-custom button-fill typo-14"><a class="btn-link"
                                                    href="https://hanbiro.com/#/en/groupware-free-trial">Free Trial</a></button>
                                            </div>
                                        </div>
                                        <div className="feature-wrap-col-ct">
                                            <div className="feature-wrap-img-ct wrap-shadow">
                                                <div className="slides-box">
                                                    <img src={`https://hanbiro.com/assets/images/cloud/mail-ai-summary-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 1" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/ai-call-en-sm-1.png?v=${new Date().getTime()}`} alt="Slide 2" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/mail-spam-settings-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 3" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/project-view-task-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 4" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/work-diary-ai-summary-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 5" />
                                                </div>
                                            </div>
                                            <div className="dot-slides-box"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="pills-feat5" role="tabpanel" aria-labelledby="pills-feat5-tab">
                                    <div className="feature-wrap-box">
                                        <div className="feature-wrap-col-ct">
                                            <p className="typo-21 typo-medium">Timecard & Vacation Management</p>
                                            <div className="sub-tt">
                                                <p className="typo-14 gray-6">Support various work styles: fixed, flexible, etc.
                                                    Automate leave management to control clock-in/out and employee days off</p>
                                            </div>

                                            <div className="feature-wrap-text">
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Mobile time tracking via GPS, WiFi, or Beacon</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Provide timecard approval features</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Export reports daily/weekly/monthly in Excel</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Monitor employee timcard and vacation status via Dashboard</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Automatically manage leave days and support incentives for using leave days.</p>
                                                </div>
                                            </div>

                                            <div class="group-button">
                                                <button class="button-custom button-fill typo-14"><a class="btn-link"
                                                    href="https://hanbiro.com/#/en/groupware-free-trial">Free Trial</a></button>
                                            </div>
                                        </div>
                                        <div className="feature-wrap-col-ct">
                                            <div className="feature-wrap-img-ct wrap-shadow">
                                                <div className="slides-box">
                                                    <img src={`https://hanbiro.com/assets/images/cloud/mail-ai-summary-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 1" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/ai-call-en-sm-1.png?v=${new Date().getTime()}`} alt="Slide 2" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/mail-spam-settings-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 3" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/project-view-task-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 4" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/work-diary-ai-summary-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 5" />
                                                </div>
                                            </div>
                                            <div className="dot-slides-box"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="pills-feat6" role="tabpanel" aria-labelledby="pills-feat6-tab">
                                    <div className="feature-wrap-box">
                                        <div className="feature-wrap-col-ct">
                                            <p className="typo-21 typo-medium">Project</p>
                                            <div className="sub-tt">
                                                <p className="typo-14 gray-6">Create work templates tailored to the business,
                                                    assign responsible persons,
                                                    and help manage progress scientifically and effectively.</p>
                                            </div>

                                            <div className="feature-wrap-text">
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Customize workflows according to
                                                        each company's specific needs</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Clear assignment,
                                                        avoid overlap,
                                                        and ensure smooth workflow</p>
                                                </div>
                                                <div className="block-li-item">
                                                    <Check className="checkbox-icon" />
                                                    <p className="typo-14 gray-6">Instant updates to
                                                        grasp real-time work progress.</p>
                                                </div>
                                            </div>

                                            <div class="group-button">
                                                <button class="button-custom button-fill typo-14"><a class="btn-link"
                                                    href="https://hanbiro.com/#/en/groupware-free-trial">Free Trial</a></button>
                                            </div>
                                        </div>
                                        <div className="feature-wrap-col-ct">
                                            <div className="feature-wrap-img-ct wrap-shadow">
                                                <div className="slides-box">
                                                    <img src={`https://hanbiro.com/assets/images/cloud/mail-ai-summary-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 1" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/ai-call-en-sm-1.png?v=${new Date().getTime()}`} alt="Slide 2" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/mail-spam-settings-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 3" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/project-view-task-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 4" />
                                                    <img src={`https://hanbiro.com/assets/images/cloud/work-diary-ai-summary-en-sm-1.png?v=${new Date().getTime()}`}
                                                        alt="Slide 5" />
                                                </div>
                                            </div>
                                            <div className="dot-slides-box"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="menu-block-wp">
                                <div className="menu-line-wp">
                                    <p className="menu-item-entry typo-14"><b>Support multiple languages</b></p>
                                    <p className="menu-item-entry typo-14"><b>ERP - SAP Integration</b></p>
                                    <p className="menu-item-entry typo-14"><b>iOS</b></p>
                                    <p className="menu-item-entry typo-14"><b>AI Integration</b></p>
                                    <p className="menu-item-entry typo-14"><b>Android</b></p>
                                    <p className="menu-item-entry typo-14"><b>Linux</b></p>
                                    <p className="menu-item-entry typo-14"><b>Mobile - Tablet</b></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </FadeInSection>
            </div>

            <div class='wrap-block global-fea1' id="services">
                <FadeInSection>
                    <div className='fit-block'>
                        <div className="wrap-block-tt">
                            <p className="typo-32">Other Services</p>
                        </div>

                        <div className="wrap-block-ct">
                            <div className="global-fea1-block">
                                <div className='wrap-content-fea1'>
                                    <div className='wrap-content-box' id="ai-call">
                                        <div className='wrap-item'>
                                            <p className='typo-21 typo-medium'>Build & manage Kubernetes Cluster infrastructure</p>
                                            <div className='fea-content-gr'>
                                                <div className='fea-content'>
                                                    <p className='typo-14'>Automatically and efficiently manage and optimize server resources</p>
                                                    <p className='typo-14'>Auto recover and scale (Auto Scaling) to ensure service stability</p>
                                                    <p className='typo-14'>Build and secure private cluster infrastructure for enterprises</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='wrap-item'>
                                            <div className='wrap-item-img'>
                                                <img
                                                    src="https://hanbiro.com/assets/images/cloud/hanbiro-global/kube-rectangle-2.png" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='wrap-content-box' id="server">
                                        <div className='wrap-item'>
                                            <p className='typo-21 typo-medium'>Manage and operate Cloud servers</p>
                                            <div className='fea-content-gr'>
                                                <div className='fea-content'>
                                                    <p className='typo-14'>Continuous 24-hour server monitoring.</p>
                                                    <p className='typo-14'>Managed and supported operations by professional engineers</p>
                                                    <p className='typo-14'>Experience in managing and operating over 8,000 servers</p>
                                                </div>
                                            </div>

                                        </div>
                                        <div className='wrap-item'>
                                            <div className='wrap-item-img'>
                                                <img
                                                    src="https://hanbiro.com/assets/images/cloud/hanbiro-global/server-rectangle-2.png" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='wrap-content-fea1'>
                                    <div className='wrap-content-box' id="kubernetes">
                                        <div className='wrap-item'>
                                            <p className='typo-21 typo-medium'>Microservices API platform deployment on the Cloud</p>
                                            <div className='fea-content-gr'>
                                                <div className='fea-content'>
                                                    <p className='typo-14'>Develop event-driven, serverless distributed architectures</p>
                                                    <p className='typo-14'>Secure access control with IAM, OAuth, and role-based authorization</p>
                                                    <p className='typo-14'>Support event automation (Messaging, Webhook, Scheduler)</p>
                                                </div>
                                            </div>

                                        </div>
                                        <div className='wrap-item'>
                                            <div className='wrap-item-img'>
                                                <img
                                                    src="https://hanbiro.com/assets/images/cloud/hanbiro-global/microservice-rectangle-2.png" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='wrap-content-box' id="ai-groupware">
                                        <div className='wrap-item'>
                                            <p className='typo-21 typo-medium'>Develop and manage AI infrastructure (LLM)</p>
                                            <div className='fea-content-gr'>
                                                <div className='fea-content'>
                                                    <p className='typo-14'>Build custom LLM and independent AI infrastructure</p>
                                                    <p className='typo-14'>Prevent corporate data leaks and protect customer data</p>
                                                    <p className='typo-14'>Manage and optimize the company's LLM models.</p>
                                                </div>
                                            </div>

                                        </div>
                                        <div className='wrap-item'>
                                            <div className='wrap-item-img'>
                                                <img
                                                    src="https://hanbiro.com/assets/images/cloud/hanbiro-global/llm-server-rectangle-2.png" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </FadeInSection>
            </div>

            <div className="wrap-block company-vn">
                <FadeInSection>
                    <div className="fit-block">
                        <div className="wrap-block-tt">
                            <p className="typo-32">Organizational Chart of Departments</p>
                        </div>

                        <div className="wrap-block-ct">
                            <div className="company-block">
                                <div className="company-box">
                                    <div className="company-item">
                                        <div>
                                            <p className="typo-21 typo-medium">Microservice</p>
                                            <p className="typo-14 gray-6">12 members</p>
                                        </div>
                                        <div className="icon-item-gr">
                                            <GroupIcon className="icon-item" />
                                        </div>
                                    </div>
                                    <div className="company-item">
                                        <div>
                                            <p className="typo-21 typo-medium">Mobile</p>
                                            <p className="typo-14 gray-6">7 members</p>
                                        </div>
                                        <div className="icon-item-gr">
                                            <GroupIcon className="icon-item" />
                                        </div>
                                    </div>
                                    <div className="company-item">
                                        <div>
                                            <p className="typo-21 typo-medium">Software Development</p>
                                            <p className="typo-14 gray-6">17 members</p>
                                        </div>
                                        <div className="icon-item-gr">
                                            <GroupIcon className="icon-item" />
                                        </div>
                                    </div>
                                </div>
                                <div className="company-box">
                                    <div className="company-item">
                                        <div>
                                            <p className="typo-21 typo-medium">Groupware</p>
                                            <p className="typo-14 gray-6">12 members</p>
                                        </div>
                                        <div className="icon-item-gr">
                                            <GroupIcon className="icon-item" />
                                        </div>
                                    </div>
                                    <div className="company-item">
                                        <div>
                                            <p className="typo-21 typo-medium">Cloud</p>
                                            <p className="typo-14 gray-6">15 members</p>
                                        </div>
                                        <div className="icon-item-gr">
                                            <GroupIcon className="icon-item" />
                                        </div>
                                    </div>
                                    <div className="company-item">
                                        <div>
                                            <p className="typo-21 typo-medium">Planning / QC</p>
                                            <p className="typo-14 gray-6">6 members</p>
                                        </div>
                                        <div className="icon-item-gr">
                                            <GroupIcon className="icon-item" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </FadeInSection>
            </div>

            <div className='wrap-block activity-vn'>
                <FadeInSection>
                    <div className='fit-block'>
                        <div className="wrap-block-tt">
                            <p className="typo-32">Company Operations</p>
                        </div>

                        <div className="wrap-block-ct">
                            <div className="activity-block">
                                <div className="activity-box">
                                    <div className="activity-item">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 7.png" />
                                    </div>
                                    <div className="activity-item">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 6.svg" />
                                    </div>
                                    <div className="activity-item">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 2.svg" />
                                    </div>
                                </div>

                                <div className="activity-box">
                                    <div className="activity-item">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 8.png" />
                                    </div>
                                    <div className="activity-item">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 3.svg" />
                                    </div>
                                    <div className="activity-item">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 4.svg" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </FadeInSection>
            </div>

            {/* <div className='wrap-block head-office' id="contact">
                <div className='fit-block'>
                    <div className="wrap-block-tt">
                        <p className="typo-32">Head Office/Branch</p>
                    </div>

                    <div className='wrap-block-ct'>
                        <ul className="nav nav-pills office-nav" id="pills-tab" role="tablist">
                            <li className="navtab-item" role="presentation">
                                <button className="nav-link office-tab typo-21 typo-medium active" id="pills-address1-tab" data-bs-toggle="pill" data-bs-target="#pills-address1" type="button" role="tab" aria-controls="pills-address1" aria-selected="true">Korea</button>
                            </li>
                            <li className="navtab-item" role="presentation">
                                <button className="nav-link office-tab typo-21 typo-medium" id="pills-address2-tab" data-bs-toggle="pill" data-bs-target="#pills-address2" type="button" role="tab" aria-controls="pills-address2" aria-selected="false">Vietnam</button>
                            </li>
                            <li className="navtab-item" role="presentation">
                                <button className="nav-link office-tab typo-21 typo-medium" id="pills-address3-tab" data-bs-toggle="pill" data-bs-target="#pills-address3" type="button" role="tab" aria-controls="pills-address3" aria-selected="false">USA</button>
                            </li>
                            <li className="navtab-item" role="presentation">
                                <button className="nav-link office-tab typo-21 typo-medium" id="pills-address4-tab" data-bs-toggle="pill" data-bs-target="#pills-address4" type="button" role="tab" aria-controls="pills-address4" aria-selected="false">China</button>
                            </li>
                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane show active" id="pills-address1" role="tabpanel" aria-labelledby="pills-address1-tab">
                                <div className='wrap-content-box-address'>
                                    <div className='item-address'>
                                        <div className='map-wp'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3928.7033289775036!2d127.01746937642758!3d37.483183428902365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca13e403a11a1%3A0x9c70026c0f395dc6!2s9%20Nambusunhwan-ro%20333-gil%2C%20Seocho%20District%2C%20Seoul%2C%20South%20Korea!5e1!3m2!1sen!2sus!4v1746694590700!5m2!1sen!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium'>Office</p>
                                            <p className='typo-14'>Address: Floors 4 and 5, No. 9 Nambusunhwan-ro 333-gil, Seocho-gu, Seoul (Hyocheon Building)</p>
                                        </div>
                                    </div>
                                    <div className='item-address'>
                                        <div className='map-wp'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3928.697113690865!2d127.01956517642732!3d37.48330162889544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca13ee3ab0e51%3A0xbddf9d0fc3e06c55!2s2481%20Nambusunhwan-ro%2C%20Seocho%20District%2C%20Seoul%2C%20South%20Korea!5e1!3m2!1sen!2sus!4v1746694664829!5m2!1sen!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium'>IDC: LG U+ Seocho Center</p>
                                            <p className='typo-14'>Address: KIDC Seocho 1 Center, 2481 Nambusunhwan-ro, Seocho-gu, Seoul</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='wrap-content-box-address'>
                                    <div className='item-address'>
                                        <div className='map-wp'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3928.7578250726233!2d126.87728017642736!3d37.48214702896173!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9e1d58ec5037%3A0x9024f7fea8edc505!2s189%20Gasan%20digital%201-ro%2C%20Geumcheon%20District%2C%20Seoul%2C%20South%20Korea!5e1!3m2!1sen!2sus!4v1746694716508!5m2!1sen!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium'>IDC: LG U+ Gasan Center</p>
                                            <p className='typo-14'>Address: 189 Gasan Digital 1-ro, Geumcheon-gu, Seoul</p>
                                        </div>
                                    </div>
                                    <div className='item-address'>
                                        <div className='map-wp'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3927.662272062719!2d127.04395757642808!3d37.50297742776926!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca405c11d34ab%3A0x99d0338105cfb048!2s322%20Teheran-ro%2C%20Gangnam%20District%2C%20Seoul%2C%20South%20Korea!5e1!3m2!1sen!2sus!4v1746694759966!5m2!1sen!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium'>IDC: Sejong Center</p>
                                            <p className='typo-14'>Address: 6th Floor, Hyundai Marine Building, 137 Teheran-ro, Gangnam-gu, Seoul</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane" id="pills-address2" role="tabpanel" aria-labelledby="pills-address2-tab">
                                <div className='wrap-content-box-address'>
                                    <div className='item-address'>
                                        <div className='map-wp'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4863.765069307557!2d106.74465547586865!3d10.765862159386801!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752be5c623d6fb%3A0x32e0a76c33f3bb5f!2sKOTITI%20Viet%20Nam%20Ltd!5e1!3m2!1sen!2sus!4v1746694828382!5m2!1sen!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium'>Office</p>
                                            <p className='typo-14 address-2'>Room 106, KOTITI, 19C Street, Tan Thuan Dong, District 7, Ho Chi Minh City</p>
                                            <p className='typo-14'>Phone number: 1800 6346</p>
                                        </div>
                                    </div>
                                    <div className='item-address'>
                                        <div className='map-wp'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4863.741162898335!2d106.74434547586871!3d10.767343159359537!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752f210b494631%3A0x6a827c97ede183c3!2sFPT%20IS!5e1!3m2!1sen!2sus!4v1746694901414!5m2!1sen!2sus" />

                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium'>IDC : FPT Telecom</p>
                                            <p className='typo-14 address-2'>Lot B3, Sang Tao Street, Tan Thuan Dong, District 7, Ho Chi Minh City 756200, Vietnam</p>
                                            <p className='typo-14'>Phone number: +84 873 002222</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane" id="pills-address3" role="tabpanel" aria-labelledby="pills-address3-tab">
                                <div className='wrap-content-box-address'>
                                    <div className='item-address'>
                                        <div className='map-wp'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4101.6200582591155!2d-118.29423002368293!3d34.05931271735594!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c77913c33649%3A0x9d865a309dbe3937!2s711%20S%20Vermont%20Ave%20%23209%2C%20Los%20Angeles%2C%20CA%2090005!5e1!3m2!1sen!2sus!4v1746694971782!5m2!1sen!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium'>Office</p>
                                            <p className='typo-14'>711 S. VERMONT AVE.STE 209 LOS ANGELES, CA 90005</p>
                                        </div>
                                    </div>
                                    <div className='item-address'>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane" id="pills-address4" role="tabpanel" aria-labelledby="pills-address4-tab">
                                <div className='wrap-content-box-address'>
                                    <div className='item-address'>
                                        <div className='map-wp'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4573.434220905642!2d113.92916638641073!3d22.51837238219087!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3403ee393751a0c5%3A0x629add8c88db8991!2zVGlhbmxpIENlbnRyYWwgQnVzaW5lc3MgUGxhemEsIOmrmOaWsOenkeaKgOWbrSBOYW4gU2hhbiBRdSwgU2hlbiBaaGVuIFNoaSwgR3VhbmcgRG9uZyBTaGVuZywgQ2hpbmEsIDUxODA2NA!5e1!3m2!1sen!2sus!4v1746695080898!5m2!1sen!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium'>Office</p>
                                            <p className='typo-14'>Room 1108G, 11th Floor, Building A, Tianli Central Business Plaza, Houhai Avenue East, Nanshan District, Shenzhen</p>
                                        </div>
                                    </div>
                                    <div className='item-address'>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <MapAddress lang={currentLang} />


            <FooterEn />
        </Sysfont>
    )
}

export default HanbiroEn;